var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-bg-white tw-rounded-md tw-p-8"},[_c('MainTab',{attrs:{"tabs":_vm.tabs,"currentTab":_vm.activeTab,"currentName":_vm.activeName},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var activeTab = ref.activeTab;
return [_c(_vm.tabs[activeTab].component,{tag:"component"})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }